import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomPagination from "../pagignation/custompagination";

const ListDynamicTable = ({
  columns,
  columnNames,
  data,
  totalRows,
  pageSize,
  currentPage,
  setCurrentPage,
  onRowClick,
  getData,
  onEditClick,
  onDeleteClick,
  showProceed = true,
  colorConditionColumn = null,  // New optional prop to specify the column to check
  colorConditionValue = null,   // The value that triggers the row color change
}) => {
  return (
    <div className="row">
      <div className="container" style={{ boxShadow: '5px 5px 15px rgba(0,0,0,0.2)', borderRadius: '10px' }}>
        <table className="table table-bordered table-hover" id="tbl">
          <thead>
            <tr className="table-dark">
              {columnNames.map((name, index) => (
                <th key={index} scope="col" className="cardBackGround">{name}</th>
              ))}
              {onEditClick && <th scope="col" className="bg-info" style={{ textAlign: 'center' }}>Edit</th>}
              {onDeleteClick && <th scope="col" className="bg-danger" style={{ textAlign: 'center' }}>Delete</th>}
              {showProceed && (
                <th scope="col" className="bg-success" style={{ textAlign: 'center' }}>Proceed</th>
              )}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => {
              // Check if the row should have a special color based on the condition column
              const rowColor = colorConditionColumn && row[colorConditionColumn] === colorConditionValue
                ? { backgroundColor: '#f8d7da' } // Red color for matching value, change as needed
                : {};

              return (
                <tr key={rowIndex} title={row.title || ''} style={rowColor}>
                  {columns.map((column, colIndex) => {
                    const cellValue = row[column];
                    return (
                      <td key={colIndex} style={column.toLowerCase().includes('pending days') ? { textAlign: 'center' } : {}}>
                      {column.toLowerCase().includes('date')
                        ? moment(cellValue, moment.ISO_8601, true).isValid()
                          ? moment(cellValue).format('DD-MMM-YYYY')
                          : ''
                        : cellValue}
                    </td>
                    );
                  })}

                  {onEditClick && (
                    <td style={{ textAlign: 'center' }}>
                      <button
                        className="btn"
                        id={`edit-${rowIndex}`}
                        title="Edit Entry"
                        onClick={() => onEditClick(row)}
                      >
                        <EditIcon sx={{ color: 'blue' }} />
                      </button>
                    </td>
                  )}
                  {onDeleteClick && (
                    <td style={{ textAlign: 'center' }}>
                      <button
                        className="btn"
                        id={`delete-${rowIndex}`}
                        title="Delete Data"
                        onClick={() => onDeleteClick(row)}
                      >
                        <DeleteIcon sx={{ color: 'red' }} />
                      </button>
                    </td>
                  )}

                  {showProceed && (
                    <td style={{ textAlign: 'center' }}>
                      <button
                        className="btn"
                        id={`proceed-${rowIndex}`}
                        title="Proceed for Entry"
                        onClick={() => onRowClick(row)}
                      >
                        <DoneOutlineIcon sx={{ color: 'green' }} />
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="text-center">
              <td colSpan={columns.length + (onEditClick ? 2 : 0) + (onDeleteClick ? 1 : 0)}>
                <CustomPagination
                  itemsCount={totalRows}
                  itemsPerPage={pageSize}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  alwaysShown={true}
                  onClick={getData}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={columns.length + (onEditClick ? 2 : 0) + (onDeleteClick ? 1 : 0)} className="text-center">
                Total {totalRows} Data
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

ListDynamicTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalRows: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  showProceed: PropTypes.bool,
  colorConditionColumn: PropTypes.string, // Optional column to check for color change
  colorConditionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // The value to match for color change
};

export default ListDynamicTable;
